




























import { Component, Mixins } from "vue-property-decorator";
import { PropertyEditableMixin, DrawerPropertyEditableMixin, LineDrawerPropertyEditableMixin, ArrowDrawerPropertyEditableMixin } from "./mixins";
import { DrawableItemEditorMixin } from "../mixins";
import LineStyleEditor from "../../../drawing/LineStyleEditor.vue";
import ArrowStyleEditor from "../../../drawing/ArrowStyleEditor.vue";
import PrintBehaviorEditor from "./PrintBehaviorEditor.vue";

@Component({
  components: {
    lineStyleEditor: LineStyleEditor,
    arrowStyleEditor: ArrowStyleEditor,
    printBehaviorEditor: PrintBehaviorEditor,
  },
})
export default class DirectiveLinePropertyEditor extends Mixins(PropertyEditableMixin, DrawableItemEditorMixin, DrawerPropertyEditableMixin, LineDrawerPropertyEditableMixin, ArrowDrawerPropertyEditableMixin) {
}
